import { NzModalService } from 'ng-zorro-antd/modal';

import { AuthoritiesConfig, RoutesGaurdConfig } from './../shared/config/authorities-config';
import { EncryptionUtil } from '../shared/utils/encryption.util';
import { NgModule, DEFAULT_CURRENCY_CODE } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemoveUnderscorePipe } from './pipes/remove-underscore';
import { TruncatePipe } from './pipes/truncate.pipe';
import { CustomCurrencyPipe } from './pipes/custom-currency.pipe';
import { MajorAmountPipe } from './pipes/major-amount.pipe';
import { TimeDiffPipe } from './pipes/time-diff.pipe';
import { MoneyFormatPipe } from './pipes/money-format.pipe';
import { SearchFilterPipe } from './pipes/search-filter';
import { BankFilterPipe } from './pipes/bank-filter';
import { TextMaskPipe } from './pipes/text-mask.pipe';
import { CapitalizeFirstLetterPipe } from './pipes/capitalize-first-letter.pipe';
import { RangePipe } from './pipes/range.pipe';
import { MapIteratorPipe } from './pipes/map-iterator.pipe';
import { RemoveDashPipe } from './pipes/remove-dash.pipe';
import { ShortNumberPipe } from './pipes/short-number,pipe';
import { AmountUnitPipe } from './pipes/amount-unit.pipe';
import { RoleCheckerPipe } from './pipes/role-checker.pipe';
import { DateSuffixPipe } from './pipes/date-suffix.pipe';
import { SplitCamelCasePipe } from './pipes/split-camel-case.pipe';
import {RemoveSlashPipe} from '../utilities/pipes/remove-slash.pipe';
import {ReplaceTextPipe} from "../utilities/pipes/replace-text.pipe";
import { DisplayDaySuffixPipe } from './pipes/display-day-suffix.pipe';

const pipes = [
	RemoveUnderscorePipe,
	TruncatePipe,
	CustomCurrencyPipe,
	MajorAmountPipe,
	TimeDiffPipe,
	MoneyFormatPipe,
	SearchFilterPipe,
	BankFilterPipe,
	TextMaskPipe,
	CapitalizeFirstLetterPipe,
	RangePipe,
	MapIteratorPipe,
	RemoveDashPipe,
	ShortNumberPipe,
	AmountUnitPipe,
	RoleCheckerPipe,
	DateSuffixPipe,
	SplitCamelCasePipe,
	RemoveSlashPipe,
	ReplaceTextPipe,
	DisplayDaySuffixPipe,
];
@NgModule({
	declarations: [...pipes],
	imports: [CommonModule],
	exports: [...pipes],
	providers: [
		AuthoritiesConfig,
		RoutesGaurdConfig,
		NzModalService,
		{
			provide: DEFAULT_CURRENCY_CODE,
			useValue: '',
		},
		EncryptionUtil,
	],
})
export class UtilitiesModule {}
